import {useState} from 'react'
import {upload} from 'utility/upload-utils'

export const Upload = props => {
  const { onChange = () => {}, multi = false } = props
  const [uploading, setUploading] = useState(false)
  const [error, setError] = useState(false)

  const onFileChange = e => {
    const file = e.target.files[0]
    setUploading(true)

    upload(file).then(response => {
      onChange(!multi ? response.data[0] : response.data, response.status)
    }).catch(e => {
      console.log(e)
      setError(true)
    }).then(() => {
      setUploading(false)
    })
  }

  return (
    <div className="row align-items-center">
      <div className={uploading ? 'col-md-10' : 'col-md-12'}>
        <input type="file" onChange={onFileChange} className="form-control" />
      </div>
      {
        error && !uploading && (
          <i className="fal fa-fa-exclamation-triangle"></i>
        )
      }
      {uploading && (
        <div className="col-md-2">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      )}
    </div>
  )
}
